
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.024 2.783A1 1 0 0110 2h4a1 1 0 01.976.783l.44 1.982a7.99 7.99 0 011.14.658l1.938-.61a1 1 0 011.166.454l2 3.464a1 1 0 01-.19 1.237l-1.496 1.373c.036.438.036.878 0 1.316l1.496 1.373a1 1 0 01.19 1.237l-2 3.464a1 1 0 01-1.166.454l-1.937-.61c-.361.251-.743.472-1.14.66l-.44 1.982A1 1 0 0114 22h-4a1 1 0 01-.976-.783l-.44-1.982a7.993 7.993 0 01-1.14-.658l-1.938.61a1 1 0 01-1.166-.454l-2-3.464a1 1 0 01.19-1.237l1.496-1.373a8.056 8.056 0 010-1.316L2.53 9.969a1 1 0 01-.19-1.237l2-3.464a1 1 0 011.166-.454l1.937.61c.362-.25.743-.471 1.141-.66l.44-1.98zM10.803 4l-.377 1.697a1 1 0 01-.612.714 5.992 5.992 0 00-1.56.901 1 1 0 01-.924.173l-1.66-.522-1.197 2.075 1.281 1.176a1 1 0 01.313.886 6.056 6.056 0 000 1.802 1 1 0 01-.313.886l-1.281 1.175 1.198 2.075 1.659-.522a1 1 0 01.924.173c.472.377.997.68 1.56.9a1 1 0 01.611.714L10.802 20h2.396l.377-1.697a1 1 0 01.611-.714 5.987 5.987 0 001.559-.902 1 1 0 01.925-.173l1.66.522 1.197-2.075-1.281-1.175a1 1 0 01-.313-.886c.09-.597.09-1.205 0-1.802a1 1 0 01.313-.886l1.281-1.176-1.198-2.074-1.659.522a1 1 0 01-.924-.173 5.992 5.992 0 00-1.56-.9 1 1 0 01-.611-.714L13.198 4h-2.396z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 10a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z"}})])
          )
        }
      }
    